var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-wrapper"},[_c('div',{ref:"line",staticClass:"pie"})])
}
var staticRenderFns = []

export { render, staticRenderFns }